
import React, { useState, useEffect } from "react";
import "./HeroSlider.css";
import Legal_Consequences from "./Legal_Consequences";
import ServicesPage from "./Practice_Areas";
import ContactSection from "./ContactSection";

import {
  FaBalanceScale,
  FaGavel
} from "react-icons/fa";

import {
  GiScales
} from "react-icons/gi";

import { Helmet } from "react-helmet";

const seo = {
  title:
    "רז יוסף – עורך דין דיני משפחה וגירושין",

  description:
    "משרד עורכי דין רז יוסף – ייעוץ וייצוג משפטי בתחום דיני המשפחה, גירושין, מזונות, משמורת ילדים, חלוקת רכוש והסכמי ממון.",

  url:
    "https://razfamilylaw.co.il/",

  image:
    "https://razfamilylaw.co.il/og-image.jpg"
};

export default function HeroSlider() {

  const images = [
    "/img1.png",
    "/img2.jpg",
    "/img3.jpg",
  ];

  const icons = [
    {
      icon: <FaBalanceScale />,
      text: "דיני משפחה"
    },
    {
      icon: <FaGavel />,
      text: "ייצוג משפטי"
    },
    {
      icon: <GiScales />,
      text: "גירושין והסכמים"
    }
  ];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>

      <Helmet>

        <title>{seo.title}</title>

        <meta
          name="description"
          content={seo.description}
        />

        <meta
          name="robots"
          content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        />

        <link
          rel="canonical"
          href={seo.url}
        />

        <meta
          property="og:type"
          content="website"
        />

        <meta
          property="og:title"
          content={seo.title}
        />

        <meta
          property="og:description"
          content={seo.description}
        />

        <meta
          property="og:url"
          content={seo.url}
        />

        <meta
          property="og:image"
          content={seo.image}
        />

        <meta
          property="og:site_name"
          content="רז יוסף – משרד עורכי דין"
        />

        <meta
          property="og:locale"
          content="he_IL"
        />

        <meta
          name="twitter:card"
          content="summary_large_image"
        />

        <meta
          name="twitter:title"
          content={seo.title}
        />

        <meta
          name="twitter:description"
          content={seo.description}
        />

        <meta
          name="twitter:image"
          content={seo.image}
        />

      </Helmet>

      <div className="slider-container">

        <img
          src={images[index]}
          alt="עורך דין רז יוסף – דיני משפחה וגירושין"
          className="main-slider"
        />

        <div className="right-overlay">

          <div className="hero-text">

            <h3 className="overlay-title">
              רז יוסף – משרד עורכי דין
            </h3>

            <h2>
              ליווי משפטי אישי ומקצועי
            </h2>

            <h2>
              מומחיות בדיני משפחה וגירושין
            </h2>

            <h2>
              ייעוץ וייצוג בסוגיות משפחתיות מורכבות
            </h2>

            <h2>
              מקצועיות, יסודיות ומחויבות לכל לקוח
            </h2>

          </div>

          <div className="images-row">

            {icons.map((item, i) => (

              <div
                className="icon-box"
                key={i}
              >

                <div className="service-icon">
                  {item.icon}
                </div>

                <span>
                  {item.text}
                </span>

              </div>

            ))}

          </div>

        </div>

      </div>

      <ServicesPage />

      <Legal_Consequences />


      <ContactSection />

    </>
  );
}
